import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'María S.',
  location: 'Buenos Aires',
  pack: 'Pack Química Inicial',
  time: 'hace 2 min'
}, {
  name: 'Juan P.',
  location: 'Córdoba',
  pack: 'Pack Química Inicial',
  time: 'hace 15 min'
}, {
  name: 'Elena R.',
  location: 'Santa Fe',
  pack: 'Pack Física + Química',
  time: 'hace 22 min'
}];
export function PurchaseToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNext = () => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
      setCurrentIndex(prev => (prev + 1) % purchases.length);
    };
    const interval = setInterval(showNext, 15000);
    const initialTimer = setTimeout(showNext, 10000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimer);
    };
  }, []);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-194">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -50
    }} className="fixed bottom-4 left-4 right-4 md:right-auto z-50 bg-white border border-blue-100 p-3 md:p-4 rounded-xl shadow-2xl flex items-center gap-3 md:gap-4 max-w-sm" data-id="element-195">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xs md:text-base shrink-0" data-id="element-196">
            {currentPurchase.name.charAt(0)}
          </div>
          <div className="flex-1" data-id="element-197">
            <div className="flex items-center justify-between" data-id="element-198">
              <p className="text-[11px] md:text-sm font-bold text-slate-900" data-id="element-199">
                {currentPurchase.name} de {currentPurchase.location} (
                {currentPurchase.pack})
                <span className="inline-block w-1.5 h-1.5 bg-green-500 rounded-full ml-1" data-id="element-200"></span>
              </p>
              <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-201">
                <X size={14} data-id="element-202" />
              </button>
            </div>
            <p className="text-xs text-slate-600" data-id="element-203">
              compró el{' '}
              <span className="text-blue-600 font-bold" data-id="element-204">
                {currentPurchase.pack}
              </span>
            </p>
            <p className="text-[10px] text-slate-400 mt-1" data-id="element-205">
              {currentPurchase.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}